import VueElementLoading from 'vue-element-loading';
import moment from 'moment';
import {getshippingidDetails} from '../../../services/ntsActions';
import {MarkNTSShipmentService, getAWBDetailsFromBag, MarkNTSBagService,ntsRoleConditoins} from '../../../services/ntsActions';
import Multiselect from 'vue-multiselect';
import { AWBNumberNormslization } from '../../../services/utility';

export default {
    name: 'AddNTSShipment',
    components: {
        VueElementLoading,
        Multiselect
    },
    data() {
        return {
            awbnumber: '',
            token: '',
            show: false,
            alldata: {},
            hubNameList: {},
            submitDisable: true,
            takeActionname: '',
            bagVisible: false,
            submitBagDisable: true,
            bagNumber: '',
            shipmentsFromBag: [],
            resultArray: [],
            SubReasons:'',
            role:'',
            shipmentsForBulk: []
        }
    },
    mounted() {
        var userToken = window.localStorage.getItem('accessuserToken');
        this.token = userToken.replace(/"/g, '');
        this.hubNameList = JSON.parse(localStorage.getItem('hubList'));
        this.hubZone = JSON.parse(localStorage.getItem('hubzoneByHubId'));
        this.takeActionname = 1
        this.role = window.localStorage.getItem('accessrole').toLowerCase().replace(/\s/g, '');
        
    },
    methods: {

        getAWBDetails(){
            if (!this.awbnumber) return this.$alertify.error("Please Enter ShippingId ");

            this.awbnumber = AWBNumberNormslization(this.awbnumber).toString();

            let input = {
                shippingid: this.awbnumber,
                markUsingBag: false,
                roleName: this.role
            }

            getshippingidDetails(input, this.token)
            .then(result => {
                let respData = result.data;
                this.resultArray = [];
                if(respData.length > 0) this.shipmentsForBulk = [];
                respData.forEach(ele => {
                    this.shipmentsForBulk.push({
                        code : ele.code,
                        message : ele.message,
                        shippingId : ele.data.shippingid,
                        currentHubName : this.hubNameList[ele.data.currenthubid],
                        destinationHubName : this.hubNameList[ele.data.finaldestinationid],
                        originHubName : this.hubNameList[ele.data.originhubid],
                        currenthubid : ele.data.currenthubid,
                        hubZoneID: this.hubZone[ele.data.currenthubid],
                    })
                })
                this.submitDisable = false;
            })
        },

        getListOfShipments(shippingId){
            let input = {
                shippingid: shippingId,
                markUsingBag: true
            }

            getshippingidDetails(input, this.token)
            .then(result => {
                let resultData = result.data.data;
                if(resultData && resultData !== undefined){
                    this.shipmentsFromBag.push({
                        code: result.data.code,
                        shippingId : shippingId,
                        currentHubName : this.hubNameList[resultData.currenthubid],
                        currenthubid : resultData.currenthubid,
                        destinationHubName : this.hubNameList[resultData.finaldestinationid],
                        originHubName : this.hubNameList[resultData.originhubid],
                        hubZoneID: this.hubZone[resultData.currenthubid],
                        message: (result.data.code !=200) ? resultData.resultData : ""
                    });
                }
                this.submitBagDisable = false;
            });
        },

        MarkNTSShipment() {
            let roleCondition=ntsRoleConditoins(this.role,this.alldata.description)

            if (!this.alldata.description || this.alldata.description == '') return this.$alertify.error("Description can not be empty");
            this.submitDisable = true;
            this.input = ({
                ShippingID: this.alldata.ShippingID,
                CurrentHubID: this.alldata.currenthubid,
                Status: 18,
                HubZoneID: this.hubZone[this.alldata.currenthubid],
                StatusMarkedFrom: 'wed',
                LastModifiedDate: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                LastModifiedBy:  window.localStorage.getItem('username'),
                RequestFrom: "Opration",
                BucketTypeCode: 1,
                Subreasons:roleCondition?roleCondition.Subreasons :' ',
                Comments : roleCondition?roleCondition.Comments:this.alldata.description,
                Sourcetype:roleCondition?roleCondition.Sourcetype :' ',


            });
            MarkNTSShipmentService(this.input, this.token).then(result => {
                if (result.data.ReturnCode == 100) {
                    this.$alertify.success(result.data.ReturnMessage);
                    this.submitDisable = false;   
                }
                else {
                    this.submitDisable = false;
                    this.$alertify.error(result.data.ReturnMessage)
                }
            });
            this.resetForm();
        },
        selectOption(event){
            if(event.target.value === "2"){
                this.bagVisible = true;
                return;
            }
            this.bagVisible = false;
        },

        fetchAWBfromBag(){
            this.resultArray = [];
            this.shipmentsFromBag = [];
            let input = {
                bagno: this.bagNumber,
                lastModifiedBy: window.localStorage.getItem('username'),
            }
            getAWBDetailsFromBag(input, this.token).then(result => {
                let shipments = result.data.ResponseData;
                if(result.data.ResultCode !== 100){
                    this.$alertify.error(result.data.ReturnMessage);
                    return;
                }
                shipments.forEach((shipment) => {
                    this.getListOfShipments(shipment);
                });
            });
        },

        markBagAsNTS(shipmentArray){
            if (!this.alldata.description || this.alldata.description == '') return this.$alertify.error("Description can not be empty");
            this.submitDisable = true;
            this.input = ({
                code: shipmentArray.code,
                ShippingIDs:shipmentArray,
                Status: 18,
                StatusMarkedFrom: 'wed',
                LastModifiedDate: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                LastModifiedBy:  window.localStorage.getItem('username'),
                Comments: this.alldata.description,
                RequestFrom: "Opration",
                BucketTypeCode: 1
            });
            if(this.role=="cotteam"){
                this.input.Subreasons='Process TAT breach'
                this.input.Comments = `COT Team:${this.alldata.description}` 
 
             }
             else{
                 this.input.Comments = this.alldata.description
 
             }

            MarkNTSBagService(this.input, this.token).then(result => {
                this.shipmentsFromBag = [];
                this.shipmentsForBulk = [];
                this.resultArray = result.data;
                // this.resetForm();
            });
        },

        resetForm() {
            this.alldata = {};
            this.$validator.reset(); this.errors.clear();
            this.shipmentsFromBag = [];
            this.shipmentsForBulk = [];
            this.resultArray = [];
        },
    }
}



// WEBPACK FOOTER //
// ./src/views/components/AddNTSShipment/AddNTSShipment.component.js